(function(angular){
	'use strict';

	var fiveYearReturnsChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {},
		controller: FiveYearReturnsChartFunction,
		controllerAs: 'fiveYearReturns'
	};

	angular
		.module('fiveYearReturnsChartModule')
		.component('fiveYearReturnsChart', fiveYearReturnsChartObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/charts/five-year-returns/five-year-returns-chart.html';
	}

	function FiveYearReturnsChartFunction() {
		var fiveYearReturns = this;

		var categorySubtitles = {
			'Fundrise': 'Platform<br/>portfolio',
			'Public&nbsp;stocks': 'Vanguard Total<br/>Stock Market ETF',
			'Public&nbsp;REITs': 'Vanguard<br/>Real Estate ETF'
		};

		fiveYearReturns.$onInit = function() {
			fiveYearReturns.chartOptions = {
				chart: {
					type: 'column'
				},
				plotOptions: {
					column: {
						colors: ['rgba(35,196,70,1)', 'rgba(184,204,214,1)', 'rgba(184,204,214,1)'],
						colorByPoint: true,
						borderWidth: 0
					},
					series: {
						dataLabels: {
							enabled: true,
							formatter: function() {
								var num = this.y;
								num = num.toFixed(2);
								num = num + "%";

								return '<span class="gamma-md text-color-white font-weight-bold">' + num + '</span>';
							},
							useHTML: true
						}
					}
				},
				series: [{
					data: [10.79, 7.92, 7.40]
				}],
				xAxis: {
					categories: ['Fundrise', 'Public&nbsp;stocks', 'Public&nbsp;REITs'],
					labels: {
						formatter: function() {
							return '<div class="gamma-md zeta text-color-white font-weight-bold">' + this.value + '</div><span class="epsilon-md eta" style="color: rgba(184,204,214,0.8);">' + categorySubtitles[this.value] + '</span>';
						},
						style: {
							textAlign: 'center'
						},
						useHTML: true
					},
					lineColor: 'rgba(184,204,214,1)',
					tickLength: 0
				},
				yAxis: {
					min: 0,
					tickInterval: 2,
					endOnTick: false,
					maxPadding: 0.25,
					labels: {
						formatter: function() {
							return '<span class="delta-md eta font-weight-bold">' + this.value + '%' + '</span>';
						},
						style: {
							color: 'rgba(184,204,214,0.6)'
						},
						useHTML: true
					},
					gridLineColor: 'rgba(184,204,214,0.25)',
					showLastLabel: false
				}
			};
		};
	}
})(window.angular);